import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Link,
  ListItem,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
  withWidth,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { NotificationImportant, PlaylistAddCheck } from "@material-ui/icons";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import ChatIcon from "@material-ui/icons/Chat";
import EditIcon from "@material-ui/icons/Edit";
import InfoIcon from "@material-ui/icons/Info";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import ChangesHistory, {
  ChangesHistoryLayout,
} from "../../../Components/ChangesHistory";
import ControlledSelect from "../../../Components/ControlledSelect";
import DialogAppBar from "../../../Components/DialogAppBar";
import EditableTypography from "../../../Components/EditableTypography";
import EmailSubscriptionList from "../../../Components/EmailSubscriptionList";
import MediaFiles from "../../../Components/MediaFiles";
import NoteSection from "../../../Components/NoteSection";
import NumericalInput from "../../../Components/NumericalInput";
import StockItemSearch from "../../../Components/StockItems/StockItemSearch";
import Title from "../../../Components/Title";
import { getDevices } from "../../../Utils/ApiCalls";
import {
  checkForClosedItem,
  ECABIN,
  formatTimeWithTZOffset,
  getDeviceType,
  getInvoiceIssuerData,
  getInvoiceIssuers,
  getToken,
  orderHasMissingSerialNoPreallocation,
  paymentStates,
  requestErrorHandler,
  shipmentStatus,
  USER_GROUPS,
} from "../../../Utils/Common";
import EnvSettings from "../../../Utils/EnvSettings";
import i18n from "../../../i18n";
import { showPopupSnackbar } from "../../../redux/actions/snackbarActions";
import DetailTabs from "../../DeviceDetails/DetailTabs";
import InvoicePreviewWindow from "../InvoicePreview2";
import OrderLine from "../OrderLine";
import ConfirmDeclineDialog from "./ConfirmDeclineDialog";
import ConfirmDeleteDialog from "./ConfirmDeleteDialog";
import CreateInvoice from "./CreateInvoice";
import FindSerialNumbers from "./FindSerialNumbers";
import ForceDevsDialog from "./ForceDevsDialog";

const server = EnvSettings.server;

const actionBarStyle = {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%",
  padding: 10,
  backgroundColor: "white",
  boxShadow: "#d6d6d6 0px 0px 15px 0px",
  zIndex: 90,
};

const actionBarSpacerStyle = { height: 100 };

const dialogContentStyle = {
  position: "relative",
  overflow: "hidden",
};

function EditOrder({ selectedOrder, width }) {
  const [editable, setEditable] = useState(false);
  const [editedOrder, setEditedOrder] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const [showDeclineDialog, setShowDeclineDialog] = useState(false);
  const [forceDevs, setForceDevs] = useState(false);
  const [productFilter, setProductFilter] = useState(false);
  const [showForceDevs, setShowForceDevs] = useState(false);
  const [automaticSerNo, setAutomaticSerNo] = useState(false);
  const [emailSubs, setEmailSubs] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const [showCreateInvoice, setShowCreateInvoice] = useState(false);
  const [mediaRefresh, setMediaRefresh] = useState(0);
  const [pendingSubmit, setPendingSubmit] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [showProductSearch, setShowProductSearch] = useState(false);
  const [showServiceSearch, setShowServiceSearch] = useState(false);
  const [serviceItems, setServiceItems] = useState([]);
  const [loadingServiceItems, setLoadingServiceItems] = useState(false);
  const [editShipping, setEditShipping] = useState(false);
  const [editDetails, setEditDetails] = useState(false);
  const [showOrderHistory, setShowOrderHistory] = useState(false);
  const [invoiceLang, setInvoiceLang] = useState();
  const [refrs, setRefresh] = useState("sdfsadfasdfasdf");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [invoiceIssuers, setInvoiceIssuers] = useState([]);

  useEffect(() => {
    getInvoiceIssuers(setInvoiceIssuers, dispatch);
  }, [dispatch]);

  const appendFetchedDevices = (devicesToAdd) => {
    setEditedOrder((currentOrder) => {
      if (!currentOrder) {
        return currentOrder;
      }
      const existingIds = new Set(
        (currentOrder.Devices || []).map((device) => device.id),
      );
      const newDevices = (devicesToAdd || []).filter(
        (device) => device?.id && !existingIds.has(device.id),
      );
      if (!newDevices.length) {
        return currentOrder;
      }
      return {
        ...currentOrder,
        Devices: [...(currentOrder.Devices || []), ...newDevices],
      };
    });
  };

  const deleteOrder = (notifcation) => {
    // Filter out events etc
    const { notifyUser, message } = notifcation;
    if (!editedOrder) {
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        orderData: editedOrder,
        ...(notifyUser ? { notifyUser: true } : {}),
        ...(message ? { deleteMessage: message } : {}),
      }),
    };
    fetch(server + "/delete_order", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          window.location.reload();
        }
      });
  };

  const _getDevices = (ser_val, searchRestrictions, count) => {
    if (!ser_val && !searchRestrictions?.DeviceProfileId) {
      return;
    }
    getDevices(
      {
        view: "search",
        search_value: ser_val || "",
        requireLCS: false,
        ...(searchRestrictions ? searchRestrictions : {}),
      },
      (result) => {
        if (!result.error) {
          if (!result.devices.length) {
            dispatch(
              showPopupSnackbar({
                message: "No devices available!",
                error: true,
              }),
            );
            return;
          }
          if (count < 0) {
            return;
          }
          var arr = result.devices;
          if (result.devices.length < count) {
            arr = arr.slice(0, arr.length);
            dispatch(
              showPopupSnackbar({
                message: "Not enough devices available!",
                error: true,
              }),
            );
          } else {
            arr = arr.slice(0, count);
          }
          appendFetchedDevices(arr);
        }
      },
    );
  };

  const editOrder = () => {
    if (!editedOrder) {
      return;
    }
    // Do not automatically create the invoice. It will be only created through the dialog
    // if (
    //   JSON.stringify(selectedOrder.genericDevices) !==
    //   JSON.stringify(editedOrder.genericDevices)
    // ) {
    //   setShowPreview(true);
    //   setSubmit(true);
    //   return;
    // }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        orderData: editedOrder,
        forceDevs: forceDevs,
      }),
    };
    fetch(server + "/edit_order", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          window.location.reload();
        }
        if (result.error && result.orders) {
          setShowForceDevs(result.orders);
        }
      });
  };

  const checkForInvoiceTrigger = () => {
    if (!selectedOrder || !editedOrder) {
      editOrder();
      return;
    }
    const shouldTrigger =
      selectedOrder.paymentStatus === "waiting" &&
      editedOrder.paymentStatus === "invoiced";
    if (!shouldTrigger) {
      editOrder();
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        resource: { type: "order", number: editedOrder.number },
      }),
    };
    fetch(server + "/get_media_files", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (result?.files?.length) {
          editOrder();
          return;
        }
        setPendingSubmit(true);
        setShowCreateInvoice(true);
      })
      .catch(() => {
        editOrder();
      });
  };

  const fetchServiceItems = (searchTerm = "") => {
    setLoadingServiceItems(true);
    fetch(server + "/get_service_items", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        search: searchTerm,
        limit: 50,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          setServiceItems(result.serviceItems || []);
        }
      })
      .catch(() => {})
      .finally(() => setLoadingServiceItems(false));
  };

  const handleAddProduct = (item) => {
    if (!item?.sku) {
      return;
    }
    if (editedOrder.genericDevices.find((g) => g.sku === item.sku)) {
      alert(item.sku + " already added!");
      return;
    }
    setEditedOrder({
      ...editedOrder,
      genericDevices: [
        ...editedOrder.genericDevices,
        {
          ...item,
          count: 1,
          price: item.listPrice,
          discount: 0,
        },
      ],
      totalPrice: editedOrder.totalPrice + (item.listPrice || 0),
    });
    setRefresh(Date.now());
  };

  const handleAddServiceItem = (item) => {
    if (!item?.sku) {
      return;
    }
    if (editedOrder.genericDevices.find((g) => g.sku === item.sku)) {
      alert(item.sku + " already added!");
      return;
    }
    setEditedOrder({
      ...editedOrder,
      genericDevices: [
        ...editedOrder.genericDevices,
        {
          ...item,
          count: 1,
          price: item.listPrice,
          discount: 0,
          type: "service",
        },
      ],
      totalPrice: editedOrder.totalPrice + (item.listPrice || 0),
    });
    setRefresh(Date.now());
  };

  useEffect(() => {
    const getSubscribers = (resource) => {
      if (!resource) {
        return;
      }
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: getToken(),
          resource: resource,
        }),
      };
      fetch(server + "/get_email_subscribers", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          requestErrorHandler(result, dispatch);
          if (!result.error) {
            setEmailSubs(result.subscribers);
          }
        });
    };
    if (selectedOrder) getSubscribers({ OrderId: selectedOrder.id });
  }, [selectedOrder, setEmailSubs, dispatch]);

  useEffect(() => {
    if (forceDevs) {
      editOrder();
    }
    // eslint-disable-next-line
  }, [forceDevs]);

  const getContentType = (val, blob) => {
    return new Blob([blob], { type: "application/pdf" });
  };

  const showInvoice = (val, callback, check, download) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        filename: val + ".pdf",
        file_location: "./invoices/" + val.replace("packing_list_", ""),
      }),
    };
    fetch(server + "/show_checklist", requestOptions)
      .then((response) => {
        const reader = response.body.getReader();
        return new ReadableStream({
          start(controller) {
            return pump();
            function pump() {
              return reader.read().then(({ done, value }) => {
                // When no more data needs to be consumed, close the stream
                if (done) {
                  controller.close();
                  return;
                }
                // Enqueue the next data chunk into our target stream
                controller.enqueue(value);
                return pump();
              });
            }
          },
        });
      })
      // Create a new response out of the stream
      .then((stream) => {
        return new Response(stream);
      })
      // Create an object URL for the response
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        // setPdfURL(blob);
        if (callback && (check || blob.size < 150)) {
          return callback(blob.size > 150);
        }
        if (download) {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", val + ".pdf");

          // Append to html link element page
          document.body.appendChild(link);

          // Start download
          link.click();

          // Clean up and remove the link
          link.parentNode.removeChild(link);
          return;
        }

        const fileName = "checklist.pdf";

        const newBlob = getContentType(val, blob);

        const newWindow = window.open("", fileName, "width=800,height=1200");
        if (newWindow) {
          setTimeout(() => {
            const dataUrl = window.URL.createObjectURL(newBlob);
            const title = newWindow.document.createElement("title");
            const iframe = newWindow.document.createElement("iframe");

            title.appendChild(document.createTextNode(fileName));
            newWindow.document.head.appendChild(title);

            iframe.setAttribute("width", "99%");
            iframe.setAttribute("height", "99%");

            iframe.setAttribute("src", dataUrl);

            newWindow.document.body.appendChild(iframe);

            setTimeout(() => {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(dataUrl);
            }, 100);
          }, 100);
        }
      })
      .catch((err) => {
        console.error(err);
        if (callback) {
          callback();
        }
      });
  };

  const allowItemChanges = () => {
    if (editedOrder.paymentStatus === "delivered") {
      return false;
    }
    if (editedOrder.paymentStatus === "transit") {
      return false;
    }
    return editable;
  };

  const allowSerNoAllocations = () => {
    if (allowItemChanges()) {
      return true;
    }
    if (
      editedOrder.paymentStatus === "transit" &&
      editedOrder.multipleShipments &&
      editable
    ) {
      return true;
    }
    return false;
  };

  const checkAllowedPaymentStates = () => {
    var list = [];
    var current = paymentStates.findIndex(
      (p) => p.value === selectedOrder?.paymentStatus,
    );
    var obj;
    paymentStates.forEach((p, i) => {
      obj = { ...p };
      if (i < current) {
        obj = { ...obj, disabled: true };
      }
      list.push(obj);
    });
    return list;
  };
  useEffect(() => {
    if (selectedOrder) {
      setEditedOrder(JSON.parse(JSON.stringify(selectedOrder)));
    }
    // eslint-disable-next-line
  }, [selectedOrder, setEditedOrder]);

  useEffect(() => {
    if (showServiceSearch) {
      fetchServiceItems("");
    }
    // eslint-disable-next-line
  }, [showServiceSearch]);

  // This func checks if the autoserdialog will be showed
  const checkForAutoSer = (e) => {
    if (!(e.target.value === "deposit" || e.target.value === "completed")) {
      return;
    }
    if (orderHasMissingSerialNoPreallocation(editedOrder)) {
      setAutomaticSerNo(true);
    }
  };

  const handleExit = () => {
    setEditable(false);
    setEditedOrder();
    setEditShipping(false);
    setEditDetails(false);
  };

  return editedOrder ? (
    <>
      <Dialog open={!!editedOrder} fullScreen onClose={handleExit}>
        <DialogContent style={dialogContentStyle}>
          <DialogAppBar
            header={t("orders.orderDetails")}
            onClose={handleExit}
          />
          <ChangesHistoryLayout
            actions={editedOrder.OrderActions}
            actionKey="order-action"
            labelPrefixes={["orders"]}
            showHistory={showOrderHistory}
            setShowHistory={setShowOrderHistory}
            width={width}
            spacing={1}
            style={{
              marginTop: 60,
              marginBottom: 20,
              paddingBottom: 30,
              position: "relative",
            }}
          >
            <ConfirmDeclineDialog
              onClose={() => {
                setShowDeclineDialog(false);
              }}
              showDialog={showDeclineDialog}
              declineOrder={(message) => {
                deleteOrder({ message: message, notifyUser: true });
              }}
            />
            <ConfirmDeleteDialog
              onClose={() => {
                setShowDialog(false);
              }}
              showDialog={showDialog}
              deleteOrder={deleteOrder}
            />
            <FindSerialNumbers
              automaticSerNo={automaticSerNo}
              getDevices={_getDevices}
              setAutomaticSerNo={setAutomaticSerNo}
              editedOrder={editedOrder}
            />
            <ForceDevsDialog
              setForceDevs={setForceDevs}
              showForceDevs={showForceDevs}
              setShowForceDevs={setShowForceDevs}
            />
            <Dialog
              open={showProductSearch}
              onClose={() => setShowProductSearch(false)}
              fullWidth
              maxWidth="md"
            >
              <DialogTitle>{t("orders.searchProducts")}</DialogTitle>
              <DialogContent>
                <FormControlLabel
                  defaultChecked={false}
                  control={
                    <Checkbox
                      onChange={(e, v) => {
                        setProductFilter(!productFilter);
                      }}
                      defaultChecked={false}
                      color="primary"
                    />
                  }
                  label={t("orders.showOnlyFinishedProducts")}
                />
                <StockItemSearch
                  allowNewItems={false}
                  onChange={(e, v) => {
                    if (v && v.sku) {
                      handleAddProduct(v);
                      setShowProductSearch(false);
                    }
                  }}
                  clearOnSelect={true}
                  includeQuantity={true}
                  includeTags={true}
                  includePacking={true}
                  placeholder={t("orders.startSearchingProducts")}
                  filters={
                    productFilter
                      ? {
                          Tags: ["Finished Product"],
                        }
                      : undefined
                  }
                  disableGridWrapper={true}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => setShowProductSearch(false)}
                  color="primary"
                >
                  {t("close")}
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={showServiceSearch}
              onClose={() => setShowServiceSearch(false)}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle>{t("orders.searchServices")}</DialogTitle>
              <DialogContent>
                <Autocomplete
                  options={serviceItems}
                  getOptionLabel={(option) => option?.sku ?? ""}
                  loading={loadingServiceItems}
                  onInputChange={(e, value) => {
                    fetchServiceItems(value || "");
                  }}
                  onChange={(e, value) => {
                    if (value && value.sku) {
                      handleAddServiceItem(value);
                      setShowServiceSearch(false);
                    }
                  }}
                  renderOption={(option) => (
                    <React.Fragment key={option?.sku || option?.id}>
                      <Grid container>
                        <Grid item xs={12}>
                          <Typography style={{ fontSize: 13 }}>
                            {option.sku}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography style={{ fontSize: 11 }}>
                            {option.name}
                          </Typography>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("orders.searchServiceItems")}
                      variant="outlined"
                    />
                  )}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => setShowServiceSearch(false)}
                  color="primary"
                >
                  {t("close")}
                </Button>
              </DialogActions>
            </Dialog>
            <Grid item sm={6} xs={12} style={{ minHeight: 300 }}>
              <Typography style={{ fontWeight: "bold" }}>
                {t("orders.billingInfo")}
              </Typography>
              <Typography>{editedOrder.clientInfo.companyName}</Typography>{" "}
              {editedOrder.clientInfo.companyAddress
                ? editedOrder.clientInfo.companyAddress
                    .split("\n")
                    .map((o, i) =>
                      o.includes(",") ? (
                        o
                          .split(",")
                          .map((v, ii) => <Typography key={ii}>{v}</Typography>)
                      ) : (
                        <Typography key={i}>{o}</Typography>
                      ),
                    )
                : null}
              <EditableTypography
                edit={editable && editedOrder?.paymentStatus === "waiting"}
                prefix={"VAT ID:"}
                onChange={(e, v) => {
                  setEditedOrder({
                    ...editedOrder,
                    clientInfo: {
                      ...editedOrder.clientInfo,
                      companyVatId: e.target.value,
                    },
                  });
                }}
              >
                {editedOrder.clientInfo.companyVatId}
              </EditableTypography>
              <Typography>{"\n"}</Typography>
              <Typography>{editedOrder.clientInfo.contactName}</Typography>{" "}
              <Typography>{editedOrder.clientInfo.contactPhone}</Typography>
              <Typography>
                {" "}
                {editedOrder.clientInfo.contactEmail}
              </Typography>{" "}
              {editedOrder.shippingInfo ? (
                <>
                  <Typography style={{ marginTop: 20, fontWeight: "bold" }}>
                    {t("orders.shippingInfo")}
                    <Tooltip title={`${t("edit")}`}>
                      <IconButton
                        onClick={() => {
                          setEditShipping(!editShipping);
                        }}
                        style={{
                          display: allowItemChanges() ? "" : "none",
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </Typography>
                  <EditableTypography
                    edit={editShipping}
                    onChange={(e, v) => {
                      setEditedOrder({
                        ...editedOrder,
                        shippingInfo: {
                          ...editedOrder.shippingInfo,
                          companyName: e.target.value,
                        },
                      });
                    }}
                    name={t("contactInfo.companyName")}
                  >
                    {editedOrder.shippingInfo.companyName}
                  </EditableTypography>
                  <EditableTypography
                    edit={editShipping}
                    onChange={(e, v) => {
                      setEditedOrder({
                        ...editedOrder,
                        shippingInfo: {
                          ...editedOrder.shippingInfo,
                          companyAddress: e.target.value,
                        },
                      });
                    }}
                    name={t("contactInfo.companyAddress")}
                    multiline
                  >
                    {editedOrder.shippingInfo.companyAddress}
                  </EditableTypography>
                  <EditableTypography
                    edit={editShipping}
                    prefix={"VAT ID:"}
                    onChange={(e, v) => {
                      setEditedOrder({
                        ...editedOrder,
                        shippingInfo: {
                          ...editedOrder.shippingInfo,
                          companyVatId: e.target.value,
                        },
                      });
                    }}
                  >
                    {editedOrder.shippingInfo.companyVatId
                      ? editedOrder.shippingInfo.companyVatId
                      : ""}
                  </EditableTypography>
                  <EditableTypography
                    edit={editShipping}
                    onChange={(e, v) => {
                      setEditedOrder({
                        ...editedOrder,
                        shippingInfo: {
                          ...editedOrder.shippingInfo,
                          contactName: e.target.value,
                        },
                      });
                    }}
                    name={t("contactInfo.contactName")}
                  >
                    {editedOrder.shippingInfo.contactName}
                  </EditableTypography>
                  <EditableTypography
                    edit={editShipping}
                    onChange={(e, v) => {
                      setEditedOrder({
                        ...editedOrder,
                        shippingInfo: {
                          ...editedOrder.shippingInfo,
                          contactPhone: e.target.value,
                        },
                      });
                    }}
                    name={t("contactInfo.contactPhone")}
                  >
                    {editedOrder.shippingInfo.contactPhone}
                  </EditableTypography>
                  <EditableTypography
                    edit={editShipping}
                    onChange={(e, v) => {
                      setEditedOrder({
                        ...editedOrder,
                        shippingInfo: {
                          ...editedOrder.shippingInfo,
                          contactEmail: e.target.value,
                        },
                      });
                    }}
                    name={t("contactInfo.contactEmail")}
                  >
                    {editedOrder.shippingInfo.contactEmail}
                  </EditableTypography>
                </>
              ) : allowItemChanges() ? (
                <Button
                  variant="outlined"
                  onClick={() => {
                    setEditedOrder({
                      ...editedOrder,
                      shippingInfo: { unknownReceiver: true },
                    });
                    setEditShipping(true);
                  }}
                >
                  {t("orders.addShippingAddress")}?
                </Button>
              ) : null}
            </Grid>
            <Grid
              item
              container
              sm={6}
              xs={12}
              spacing={1}
              alignContent="flex-start"
            >
              {editedOrder.metadata &&
                editedOrder.metadata.dealId &&
                !editedOrder.metadata.wooOrderId && (
                  <Grid item xs={12}>
                    <Typography>{t("orders.createdFromHubspot")}</Typography>
                    <Link
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        window.open(
                          "https://app.hubspot.com/contacts/5998742/record/0-3/" +
                            editedOrder.metadata.dealId,
                        );
                      }}
                    >
                      {editedOrder.metadata.dealId}
                    </Link>
                  </Grid>
                )}
              {editedOrder.metadata && editedOrder.metadata.wooOrderId && (
                <Grid item xs={12}>
                  <Typography>{t("orders.createdFromWoocommerce")}</Typography>
                  <Link
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      window.open(
                        "https://ctn.fi/store20/wp-admin/post.php?post=" +
                          editedOrder.metadata.wooOrderId +
                          "&action=edit",
                      );
                    }}
                  >
                    {editedOrder.metadata.wooOrderId}
                  </Link>
                  <Typography>{"HubSpot Deal ID"} </Typography>
                  <Link
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      window.open(
                        "https://app.hubspot.com/contacts/5998742/record/0-3/" +
                          editedOrder.metadata.dealId,
                      );
                    }}
                  >
                    {editedOrder.metadata.dealId}
                  </Link>
                </Grid>
              )}
              <Grid item xs={12}>
                <Typography>
                  {t("orders.orderNumber")}: {editedOrder.number}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  {t("orders.invoiceIssuer")}:{" "}
                  {getInvoiceIssuerData(
                    invoiceIssuers,
                    editedOrder.invoiceIssuer,
                  )?.name || editedOrder.invoiceIssuer}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  {t("createdBy")}: {editedOrder.User?.fullName}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  {t("createdAt")}:{" "}
                  {formatTimeWithTZOffset(editedOrder.createdAt, ECABIN)}
                </Typography>
              </Grid>
              {editedOrder.paymentDate ? (
                <Grid item xs={12}>
                  <Typography>
                    {t("orders.paymentDate")}:{" "}
                    {formatTimeWithTZOffset(editedOrder.paymentDate, ECABIN)}
                  </Typography>
                </Grid>
              ) : null}
              {editedOrder.deliveryDate ? (
                <Grid item xs={12}>
                  <Typography>
                    {t("orders.deliveryDate")}:{" "}
                    {formatTimeWithTZOffset(editedOrder.deliveryDate, ECABIN)}
                  </Typography>
                </Grid>
              ) : null}
              <Grid item xs={12}>
                <ControlledSelect
                  itemlist={checkAllowedPaymentStates()}
                  label={t("orders.paymentStatus")}
                  defaultValue={editedOrder.paymentStatus}
                  onChange={(e, v) => {
                    if (!e.target?.value) {
                      setEditedOrder({
                        ...editedOrder,
                        paymentStatus: selectedOrder.paymentStatus,
                      });
                      return;
                    }
                    setEditedOrder({
                      ...editedOrder,
                      paymentStatus: e.target.value,
                    });
                    checkForAutoSer(e);
                  }}
                  deleteButton={true}
                  disabled={!editable}
                  usingTranslation={(data) => {
                    return t("paymentStates." + data);
                  }}
                />
              </Grid>
              {editedOrder.paymentStatus === "deposit" ? (
                <Grid item xs={12} style={{ marginTop: 5 }}>
                  <NumericalInput
                    variant="outlined"
                    fullWidth
                    label={t("orders.depositAmount")}
                    type="number"
                    defaultValue={editedOrder.depositAmount || ""}
                    disabled={!editable}
                    inputProps={{ min: 0, max: editedOrder.totalPrice }}
                    onChange={(e, v) => {
                      if (!e.target?.value) {
                        setEditedOrder({ ...editedOrder, depositAmount: null });
                        return;
                      }
                      setEditedOrder({
                        ...editedOrder,
                        depositAmount: e.target.value,
                      });
                    }}
                  />
                </Grid>
              ) : null}
              {/* {editedOrder.number ? (
                <Grid item xs={12}>
                  <Button
                    onClick={() => {
                      showInvoice(editedOrder.number);
                    }}
                    startIcon={<Description />}
                    variant="outlined"
                  >
                    {t("show") + " " + t("invoice")}
                  </Button>
                </Grid>
              ) : null} */}
              {editedOrder.Shipments && editedOrder.Shipments.length ? (
                <>
                  <Title>
                    {t("shipments.header")}
                    {editedOrder.multipleShipments ? (
                      <Tooltip
                        title={
                          <Typography style={{ fontSize: 15 }}>
                            {t("orders.multipleShipments")}
                          </Typography>
                        }
                      >
                        <IconButton>
                          <InfoIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                  </Title>

                  {editedOrder.Shipments.map((m, i) => (
                    <Tooltip title={"Show Shipment"} key={i}>
                      <ListItem
                        button
                        onClick={() => {
                          history.push("/cpanel/shipments/" + m.number);
                        }}
                        style={{
                          border: "1px solid #000",
                          backgroundColor:
                            shipmentStatus.find((f) => f.value === m.status)
                              ?.color || "",
                        }}
                      >
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography style={{ fontSize: 15 }}>
                              {m.number} -{" "}
                              {t(
                                "shipmentStates." +
                                  (shipmentStatus.find(
                                    (f) => f.value === m.status,
                                  )?.value || "waiting"),
                              )}
                            </Typography>
                          </Grid>
                          {m.genericDevices &&
                            m.genericDevices.map((mm, i) =>
                              mm.count ? (
                                <Grid item xs={12} key={i}>
                                  <Typography style={{ fontSize: 12 }}>
                                    {mm.name + " x " + mm.count}
                                  </Typography>
                                </Grid>
                              ) : null,
                            )}
                        </Grid>
                      </ListItem>
                    </Tooltip>
                  ))}
                </>
              ) : null}
              {editedOrder.paymentStatus === "completed" ||
              editedOrder.paymentStatus === "transit" ||
              editedOrder.paymentStatus === "deposit" ? (
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      history.push(
                        "/cpanel/shipments/new/order/" + editedOrder.number,
                      );
                    }}
                    style={{ marginTop: 5 }}
                  >
                    {t("orders.addNewShipment")}
                  </Button>
                </Grid>
              ) : null}
            </Grid>
            <Grid item xs={12}>
              <Typography style={{ fontWeight: "bold" }}>
                {t("details")}
                <Tooltip title={`${t("edit")}`}>
                  <IconButton
                    style={{
                      display: editable ? "" : "none",
                    }}
                    onClick={() => {
                      setEditDetails(!editDetails);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              </Typography>
              <EditableTypography
                edit={editDetails}
                name={t("details")}
                onChange={(e, v) => {
                  setEditedOrder({ ...editedOrder, details: e.target.value });
                }}
              >
                {editedOrder.details}
              </EditableTypography>
            </Grid>
            <Grid item xs={12}>
              <DetailTabs
                activeTabs={[
                  {
                    permission: [USER_GROUPS.ADMIN, USER_GROUPS.SUPER_USER],
                    label: (
                      <>
                        <ShoppingCartIcon /> {t("items")}
                      </>
                    ),
                    content: (
                      <>
                        <Grid item xs={12}>
                          {allowItemChanges() ? (
                            <>
                              <Grid item xs={12}>
                                <Title>{t("orders.itemSearch")}</Title>
                              </Grid>
                              <Grid item xs={12} container spacing={1}>
                                <Grid item>
                                  <Button
                                    variant="outlined"
                                    onClick={() => setShowProductSearch(true)}
                                  >
                                    {t("orders.searchProducts")}
                                  </Button>
                                </Grid>
                                <Grid item>
                                  <Button
                                    variant="outlined"
                                    onClick={() => setShowServiceSearch(true)}
                                  >
                                    {t("orders.searchServices")}
                                  </Button>
                                </Grid>
                              </Grid>
                            </>
                          ) : null}
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          container
                          style={{ borderTop: "1px solid #000", marginTop: 10 }}
                        >
                          <Grid item sm={3} xs={3}>
                            <Typography>{t("description")}</Typography>
                          </Grid>
                          {allowItemChanges() ? (
                            <Grid item xs={4}></Grid>
                          ) : null}
                          <Grid item sm={allowItemChanges() ? 1 : 2} xs={3}>
                            <Typography style={{ textAlign: "right" }}>
                              {editedOrder?.Shipments?.length
                                ? "(" +
                                  t("orders.allocatedInShipments") +
                                  ") / "
                                : ""}
                              {t("orders.numberItems")}
                            </Typography>
                          </Grid>
                          <Grid item sm={allowItemChanges() ? 1 : 2} xs={3}>
                            <Typography style={{ textAlign: "right" }}>
                              {t("orders.unitPrice")}
                            </Typography>
                          </Grid>
                          <Grid item sm={allowItemChanges() ? 1 : 2} xs={3}>
                            <Typography style={{ textAlign: "right" }}>
                              {t("orders.discount") + "%"}
                            </Typography>
                          </Grid>
                          <Grid item sm={allowItemChanges() ? 1 : 2} xs={3}>
                            <Typography style={{ textAlign: "right" }}>
                              {t("orders.unitTotal")}
                            </Typography>
                          </Grid>
                          {width === "xs" ? null : <Grid item xs={1}></Grid>}
                        </Grid>
                        {editedOrder.genericDevices &&
                          editedOrder.genericDevices.map((dev, i) => (
                            <OrderLine
                              key={i}
                              item={dev}
                              selectedProducts={editedOrder.genericDevices}
                              totalItems={editedOrder.genericDevices.reduce(
                                (partialSum, a) => partialSum + a.count,
                                0,
                              )}
                              setTotalItems={() => {}}
                              setTotalPrice={() => {}}
                              setSelectedProducts={(e, v) => {
                                setEditedOrder({
                                  ...editedOrder,
                                  genericDevices: e,
                                  totalPrice: e.reduce(
                                    (partialSum, a) =>
                                      partialSum +
                                      a.count *
                                        (a.price *
                                          ((100 - (a.discount || 0)) / 100)),
                                    0,
                                  ),
                                });
                                // setRefresh(Date.now());
                              }}
                              totalPrice={editedOrder.totalPrice}
                              onlyPrint={!allowItemChanges()}
                              serialNumberAllocation={
                                editedOrder.paymentStatus === "completed" ||
                                editedOrder.paymentStatus === "deposit" ||
                                editedOrder.Devices.length
                                  ? editedOrder.Devices
                                  : undefined
                              }
                              editedOrder={editedOrder}
                              setEditedOrder={setEditedOrder}
                              editable={allowItemChanges()}
                              allowSerNoAllocations={allowSerNoAllocations()}
                              width={width}
                            />
                          ))}
                        <Grid
                          item
                          container
                          xs={12}
                          style={{ borderTop: "1px solid #000" }}
                        >
                          {width === "xs" ? null : <Grid item xs={2}></Grid>}
                          <Grid item sm={2} xs={3}>
                            <Typography
                              style={{ textAlign: "right", padding: 5 }}
                            >
                              {t("orders.totalItems")}
                            </Typography>
                          </Grid>
                          <Grid item sm={1} xs={3}>
                            <Typography
                              style={{ textAlign: "right", padding: 5 }}
                            >
                              {editedOrder.genericDevices.reduce(
                                (partialSum, a) => partialSum + a.count,
                                0,
                              )}
                            </Typography>
                          </Grid>
                          {width === "xs" ? null : <Grid item xs={4}></Grid>}
                          <Grid item sm={1} xs={3}>
                            <Typography
                              style={{ textAlign: "right", padding: 5 }}
                            >
                              {t("orders.totalPrice")}
                            </Typography>
                          </Grid>
                          <Grid item sm={1} xs={3} key={refrs + "" + 1}>
                            <Typography
                              style={{ textAlign: "right", padding: 5 }}
                            >
                              {editedOrder.totalPrice.toFixed(2)}{" "}
                              {editedOrder.currency}
                            </Typography>
                          </Grid>
                          {width === "xs" ? null : <Grid item xs={1}></Grid>}
                        </Grid>
                        <Grid
                          item
                          container
                          xs={12}
                          style={{ borderTop: "1px solid #000" }}
                        >
                          {width === "xs" ? null : <Grid item xs={4}></Grid>}
                          <Grid item sm={1} xs={3}>
                            <Typography
                              style={{ textAlign: "right", padding: 5 }}
                            >
                              {t("orders.vat") + "%"}
                            </Typography>
                          </Grid>
                          <Grid item sm={2} xs={3}>
                            <EditableTypography
                              style={{ textAlign: "right", padding: 5 }}
                              edit={
                                editable &&
                                editedOrder?.paymentStatus === "waiting"
                              }
                              onChange={(e, v) => {
                                setEditedOrder({
                                  ...editedOrder,
                                  vat: e.target.value,
                                });
                              }}
                              name={""}
                              type={"number"}
                              suffix={"%"}
                            >
                              {editedOrder.vat}
                            </EditableTypography>
                            {/* <Typography
                              style={{ textAlign: "right", padding: 5 }}
                            >
                              {editedOrder.vat || 0}%
                            </Typography> */}
                          </Grid>
                          {width === "xs" ? null : <Grid item xs={1}></Grid>}
                          <Grid item sm={2} xs={3} key={refrs + "" + 2}>
                            <Typography
                              style={{ textAlign: "right", padding: 5 }}
                            >
                              {t("orders.totalPrice") + " + " + t("orders.vat")}
                            </Typography>
                          </Grid>
                          <Grid item sm={1} xs={3} key={refrs + "" + 3}>
                            <Typography
                              style={{ textAlign: "right", padding: 5 }}
                            >
                              {(
                                editedOrder.totalPrice *
                                (1 + editedOrder.vat / 100)
                              ).toFixed(2)}{" "}
                              {editedOrder.currency}
                            </Typography>
                          </Grid>
                          {width === "xs" ? null : <Grid item xs={1}></Grid>}
                        </Grid>
                      </>
                    ),
                  },
                  {
                    label: (
                      <>
                        <PlaylistAddCheck />{" "}
                        {t("orders.allocatedSerialNumbers")}
                      </>
                    ),
                    content: (
                      <>
                        <Grid item xs={12}>
                          {editedOrder &&
                            editedOrder.Devices.map((d) => (
                              <Grid item xs={12}>
                                <Link
                                  key={d.serialNumber}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    history.push("/cpanel/devices/" + d.id);
                                  }}
                                >
                                  {getDeviceType(d.serialNumber)} -{" "}
                                  {d.serialNumber}
                                </Link>
                              </Grid>
                            ))}
                        </Grid>
                      </>
                    ),
                  },
                  {
                    permission: [USER_GROUPS.ADMIN, USER_GROUPS.SUPER_USER],
                    label: (
                      <>
                        <AttachFileIcon
                          style={{ fontSize: 20, verticalAlign: "middle" }}
                        />
                        {t("media")}
                      </>
                    ),
                    content: (
                      <>
                        <Grid item xs={12} style={{ marginBottom: 10 }}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              setShowCreateInvoice(true);
                            }}
                          >
                            + {t("create")} {t("invoice")}
                          </Button>
                        </Grid>
                        <MediaFiles
                          resource={{
                            type: "order",
                            number: editedOrder.number,
                            refresh: mediaRefresh,
                          }}
                          listCallback={() => {}}
                        />
                      </>
                    ),
                  },
                  {
                    permission: [USER_GROUPS.ADMIN, USER_GROUPS.SUPER_USER],
                    label: (
                      <>
                        <ChatIcon />
                        {t("notes")}
                      </>
                    ),
                    content: (
                      <NoteSection
                        parent={{ OrderId: editedOrder.id }}
                        notes={editedOrder.Notes}
                        reload={() => {
                          window.location.reload();
                        }}
                        noPaper={true}
                      />
                    ),
                  },
                  {
                    label: (
                      <>
                        <NotificationImportant></NotificationImportant>
                        {t("emailSubscriptionList.header")}
                      </>
                    ),
                    content: <EmailSubscriptionList emailSubs={emailSubs} />,
                  },
                  width === "xs"
                    ? {
                        permission: [USER_GROUPS.ADMIN, USER_GROUPS.SUPER_USER],
                        label: t("ticketList.changesHistory"),
                        content: (
                          <ChangesHistory
                            actions={editedOrder.OrderActions}
                            actionKey="order-action"
                            labelPrefixes={["orders"]}
                          />
                        ),
                      }
                    : null,
                ]}
              />
            </Grid>

            {JSON.stringify(selectedOrder.genericDevices) !==
            JSON.stringify(editedOrder.genericDevices) ? (
              <Grid item xs={12} container>
                <Grid item xs={12}>
                  <Typography>{t("orders.invoiceLanguage")}</Typography>
                </Grid>

                <TextField
                  select
                  defaultValue={i18n.language}
                  onChange={(e, v) => {
                    setInvoiceLang(e.target.value);
                  }}
                  variant="outlined"
                >
                  <MenuItem value="en" key={"en"} label="English">
                    English
                  </MenuItem>
                  <MenuItem value="fi" key={"fi"} label="Suomi">
                    Suomi
                  </MenuItem>
                </TextField>
              </Grid>
            ) : null}
            <Grid item xs={12} style={actionBarSpacerStyle} />
          </ChangesHistoryLayout>
          <div style={actionBarStyle}>
            <Grid container item xs={12} spacing={1}>
              <Grid item>
                <Button
                  variant="outlined"
                  disabled={checkForClosedItem(selectedOrder, "order")}
                  onClick={() => {
                    if (editable) {
                      setEditedOrder(JSON.parse(JSON.stringify(selectedOrder)));
                    }
                    setEditable(!editable);
                    setEditDetails(false);
                    setEditShipping(false);
                  }}
                >
                  {!editable ? t("edit") : t("cancel")}
                </Button>
              </Grid>
              {checkForClosedItem(selectedOrder, "order") && (
                <Grid item>
                  <Typography>{t("itemIsClosed")}</Typography>
                </Grid>
              )}
              {editable ? (
                <>
                  {/* 
                  Allow invoice creation only from the invoice creation dialog
                  {JSON.stringify(selectedOrder.genericDevices) !==
                  JSON.stringify(editedOrder.genericDevices) ? (
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          setShowPreview(true);
                        }}
                      >
                        {t("preview")}
                      </Button>
                    </Grid>
                  ) : null} */}
                  <Grid item>
                    <Button
                      variant="contained"
                      disabled={
                        (selectedOrder.Devices.length ===
                          editedOrder.Devices.length &&
                          JSON.stringify(editedOrder) ===
                            JSON.stringify(selectedOrder)) ||
                        !editedOrder.genericDevices.length ||
                        !editedOrder.genericDevices.reduce(
                          (partialSum, a) => partialSum + a.count,
                          0,
                        )
                      }
                      color="primary"
                      onClick={checkForInvoiceTrigger}
                    >
                      {t("save")}
                    </Button>
                  </Grid>
                  {selectedOrder?.paymentStatus === "waiting" ? (
                    <Grid item>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          setShowDeclineDialog(true);
                        }}
                      >
                        {t("orders.declineOrder")}
                      </Button>
                    </Grid>
                  ) : (
                    <Grid item>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          setShowDialog(true);
                        }}
                      >
                        {t("delete")}
                      </Button>
                    </Grid>
                  )}
                </>
              ) : null}
            </Grid>
          </div>
        </DialogContent>
      </Dialog>
      {/* Preview needs to be outside the Grid otherwise the PDF print does not zoom correctly */}
      <InvoicePreviewWindow
        show={showPreview}
        submit={submit}
        setSubmit={setSubmit}
        setShow={setShowPreview}
        selectedProducts={editedOrder.genericDevices}
        totalItems={editedOrder.genericDevices.reduce(
          (partialSum, a) => partialSum + a.count,
          0,
        )}
        totalPrice={editedOrder.totalPrice}
        currency={editedOrder.currency}
        clientInfoObject={editedOrder.clientInfo}
        shippingInfo={editedOrder.shippingInfo}
        issuer={editedOrder.invoiceIssuer}
        invoiceLang={invoiceLang}
        saveContact={false}
        width={width}
        vat={editedOrder.vat}
        details={editedOrder.details}
        orderNumber={editedOrder.number}
        editedOrder={editedOrder}
      />
      <CreateInvoice
        showInvoice={showCreateInvoice ? editedOrder : null}
        setShowInvoice={setShowCreateInvoice}
        callback={() => {
          setMediaRefresh(Date.now());
        }}
        onFinish={() => {
          if (pendingSubmit) {
            setPendingSubmit(false);
            editOrder();
          }
        }}
        emailSubs={emailSubs}
      />
    </>
  ) : null;
}

export default withWidth()(EditOrder);
